import type { ThemingProps } from '@chakra-ui/react';
import { createContext } from '@chakra-ui/react-utils';

export interface PopoverContext {
  size: ThemingProps<'Button'>['size'];
  hasArrow: boolean;
}

const [PopoverProvider, usePopoverContext] = createContext<PopoverContext>({
  name: 'PopoverContext',
  errorMessage:
    'usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`',
});

export { PopoverProvider, usePopoverContext };
